import { render, staticRenderFns } from "./Layout.vue?vue&type=template&id=4bfa17c2"
import script from "./layout.ts?vue&type=script&lang=js&external"
export * from "./layout.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports